import { FiltersBar, SearchInput, useFilterUpdate } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { usePendingShipmentListFilter } from './usePendingShipmentListFilter';

export function Filters() {
  const { search, setSearch } = usePendingShipmentListFilter();
  const { t } = useTranslation();

  useFilterUpdate('search', search);

  return (
    <FiltersBar.Row>
      <SearchInput
        placeholder={t('pendingShipment.list.searchPlaceholder')}
        onChange={v => setSearch(v)}
        defaultValue={search}
      />
    </FiltersBar.Row>
  );
}
